/**
 * App version — bump this when pushing a new build so you can verify on
 * each environment has the expected build. Rendered in the sidebar footer
 * as a tiny "v1.00" label.
 *
 * Bump pattern: 1.00 → 1.01 → 1.02 → ... → 1.99 → 2.00
 */
export const APP_VERSION = "8.45";
